import { buildProps } from "@element-customer-plus/utils"
import { panelRangeSharedProps, panelSharedProps, HolidayData } from "./shared"

import type { ExtractPropTypes } from "vue"

export const panelDateRangeProps = buildProps({
  ...panelSharedProps,
  ...panelRangeSharedProps,
  visible: Boolean,
  holidays: {
    type: Object as () => HolidayData,
    default: () => ({}),
  },
} as const)

export type PanelDateRangeProps = ExtractPropTypes<typeof panelDateRangeProps>
